// Real EVO exhibition projects (client-provided photos + details).
// Titled by EXHIBITION (never by client) to protect client branding.
// `crop` frames out top client fascia without altering the stand design.
const IMG = {
  gitex: "https://customer-assets-cm19k8pv.emergentagent.net/job_evo-corp/artifacts/vh4sd3u1_parkin.jpg",
  adipec: "https://customer-assets-cm19k8pv.emergentagent.net/job_evo-corp/artifacts/aca7voah_2d339848-840e-4ea8-b37f-7346fed11647.jpg",
  gulfood1: "https://customer-assets-cm19k8pv.emergentagent.net/job_evo-corp/artifacts/pzak7buf_ce6c5584-f331-4f45-a182-f4758d110fb8.jpg",
  gulfood2: "https://customer-assets-cm19k8pv.emergentagent.net/job_evo-corp/artifacts/4e7veclk_2b35ec3c-64d8-48dc-8b2d-0d281adf67bf.jpg",
  gulfood3: "https://customer-assets-cm19k8pv.emergentagent.net/job_evo-corp/artifacts/4gllqwuy_8292ebea-b847-4a1b-b2f2-b6ab1cdcbf97.jpg",
};

const SERVICES = ["Exhibition Stand Design & Build", "Project Management", "Installation"];

export const PROJECTS = [
  {
    id: "project-1", span: "md:col-span-7", ratio: "aspect-[16/10]", crop: "center 58%", image: IMG.gitex,
    projectName: "GITEX", exhibitionName: "GITEX Global", location: "Dubai, UAE", industry: "Technology & Innovation", services: SERVICES,
    overview: "GITEX Global is the region's largest technology exhibition — a fast-moving show floor where innovation brands compete for the attention of a global audience.",
    evoSolution: "EVO designed and built an immersive, light-driven technology stand: a bold architectural form with integrated LED surfaces, layered levels and a carefully controlled visitor flow that turned the space into an experience rather than a booth.",
    impact: "A commanding presence among global technology leaders, giving the brand a confident platform to host meetings, run demonstrations and draw sustained footfall.",
    gallery: [],
  },
  {
    id: "project-2", span: "md:col-span-5", ratio: "aspect-[4/5]", crop: "center 45%", image: IMG.adipec,
    projectName: "ADIPEC", exhibitionName: "ADIPEC", location: "Abu Dhabi, UAE", industry: "Energy", services: SERVICES,
    overview: "ADIPEC is one of the world's most significant energy exhibitions, convening industry leaders and decision-makers from across the sector.",
    evoSolution: "EVO delivered a multi-level energy pavilion with a robust architectural language, premium materials and dedicated hospitality and meeting zones — engineered for high footfall and serious business conversations.",
    impact: "A professional, high-capacity environment that supported briefings, meetings and networking throughout the exhibition.",
    gallery: [],
  },
  {
    id: "project-3", span: "md:col-span-5", ratio: "aspect-[4/5]", crop: "center 60%", image: IMG.gulfood1,
    projectName: "Gulfood", exhibitionName: "Gulfood", location: "Dubai, UAE", industry: "Food & Beverage", services: SERVICES,
    overview: "Gulfood is the world's largest annual food and beverage exhibition — a highly competitive stage for brands across the industry.",
    evoSolution: "EVO created a warm, product-focused stand with sampling and hospitality areas, sculptural branding features and a layout designed to welcome and retain visitors.",
    impact: "An inviting destination on the show floor that encouraged tasting, conversation and lasting brand recall.",
    gallery: [],
  },
  {
    id: "project-4", span: "md:col-span-7", ratio: "aspect-[16/10]", crop: "center 55%", image: IMG.gulfood2,
    projectName: "Gulfood", exhibitionName: "Gulfood", location: "Dubai, UAE", industry: "Food & Beverage", services: SERVICES,
    overview: "At Gulfood, standing out demands both craft and clarity amid thousands of exhibitors competing for buyers' attention.",
    evoSolution: "EVO engineered an open, double-height structure with clear sightlines, illuminated branding and dedicated tasting and meeting spaces.",
    impact: "A confident, open stand that drew steady footfall and gave the brand room to host buyers and partners in comfort.",
    gallery: [],
  },
  {
    id: "project-5", span: "md:col-span-12", ratio: "aspect-[21/9]", crop: "center 42%", image: IMG.gulfood3,
    projectName: "Gulfood", exhibitionName: "Gulfood", location: "Dubai, UAE", industry: "Food & Beverage", services: SERVICES,
    overview: "Gulfood gathers the global food and beverage community across vast exhibition halls in Dubai.",
    evoSolution: "EVO delivered a striking, colour-led environment with immersive lighting, feature displays and a considered visitor journey from first glance to final handshake.",
    impact: "A vibrant, memorable presence that reinforced the brand's positioning at a flagship international show.",
    gallery: [],
  },
];

export const getProject = (id) => {
  const i = PROJECTS.findIndex((p) => p.id === id);
  if (i === -1) return { project: null };
  return { project: PROJECTS[i], index: i, next: PROJECTS[(i + 1) % PROJECTS.length] };
};
